import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { enUS } from "@mui/material/locale";
import { scsmsTokens as t } from "./brandTokens";
import { getComponentOverrides } from "./componentOverrides";

export type ScsmsThemeLanguage = "en";

export function createScsmsTheme(options: { lang?: ScsmsThemeLanguage } = {}) {
  const locale = enUS;

  let theme = createTheme(
    {
      palette: {
        mode: "light",
        primary: {
          main: t.color.primary[700],
          dark: t.color.primary[800],
          light: t.color.primary[300],
          contrastText: "#FFFFFF",
        },
        secondary: {
          main: t.color.secondary[500],
          dark: t.color.secondary[700],
          light: t.color.secondary[300],
          contrastText: "#FFFFFF",
        },
        background: {
          default: t.color.neutral[50],
          paper: t.color.neutral[0],
        },
        text: {
          primary: t.color.neutral[800],
          secondary: t.color.neutral[500],
        },
        success: { main: t.color.accent.success },
        warning: { main: t.color.accent.warning },
        error: { main: t.color.accent.danger },
        info: { main: t.color.accent.info },
        divider: t.color.neutral[200],
      },
      shape: { borderRadius: t.radius.md },
      typography: {
        fontFamily: '"Inter", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
        h1: { fontSize: "2.25rem", fontWeight: 800, letterSpacing: "-0.03em", color: t.color.neutral[800] },
        h2: { fontSize: "1.875rem", fontWeight: 800, letterSpacing: "-0.03em", color: t.color.neutral[800] },
        h3: { fontSize: "1.5rem", fontWeight: 800, letterSpacing: "-0.02em", color: t.color.neutral[800] },
        h4: { fontSize: "1.25rem", fontWeight: 700, color: t.color.neutral[800] },
        h5: { fontSize: "1.125rem", fontWeight: 700, color: t.color.neutral[800] },
        h6: { fontSize: "1rem", fontWeight: 700, color: t.color.neutral[800] },
        subtitle1: { fontSize: "0.95rem", fontWeight: 600, color: t.color.neutral[700] },
        subtitle2: { fontSize: "0.875rem", fontWeight: 700, color: t.color.neutral[600], textTransform: "uppercase", letterSpacing: "0.06em" },
        body1: { fontSize: "0.95rem", lineHeight: 1.7, color: t.color.neutral[700] },
        body2: { fontSize: "0.875rem", lineHeight: 1.65, color: t.color.neutral[500] },
        button: { fontWeight: 700, textTransform: "none" },
        caption: { fontSize: "0.75rem", color: t.color.neutral[500] },
      },
      spacing: 8,
    },
    locale
  );

  theme = createTheme(theme, { components: getComponentOverrides(theme) });
  return responsiveFontSizes(theme);
}
